import { ModuleLink } from '@bv/router';

import { canAccessIntegrations, canAccessNewBillingFeatures } from '@/utils/workspace-info';

export const modules: ModuleLink[] = [
  {
    icon: 'bvi-dashboard',
    title: 'GLOBAL.TOP_BAR.HOME',
    visible: true,
    route: { name: 'dashboard' },
  },
  {
    icon: 'bvi-receipt',
    title: 'GLOBAL.SUBSCRIPTION_DETAILS',
    visible: canAccessNewBillingFeatures,
    route: { name: 'account-details' },
  },
  {
    icon: 'bvi-integration',
    title: 'integrations.title_trans',
    visible: canAccessIntegrations,
    route: { name: 'integrations' },
  },
];
